/*
 * Returns true if the portfolioCompany has a company object. Portfolio companies always have either
 * a company or a requested_company, so the presence of the company field is sufficient for
 * identifying portfolio companies as verified.
 */
export default (portfolioCompany) => Boolean(portfolioCompany?.company);
